import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';
import IconCheck from '../../../assets/icons/source/check.svg';

import { CheckStyled, Check, IconContainer } from './Checkbox.styled';

const Checkbox = ({
  modifiers, label, disabled, ...props
}) => {
  const modifiersArray = Array.isArray(modifiers) ? modifiers : [modifiers];
  if (disabled) {
    modifiersArray.push('disabled');
  }
  return (
    <CheckStyled modifiers={modifiersArray}>
      <Check {...props} />
      <IconContainer>
        <IconCheck />
      </IconContainer>
      {label}
    </CheckStyled>
  );
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  modifiers: CustomTypes.oneOrMore(['', 'checkbox', 'radial', 'disabled', 'deactivated']),
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

Checkbox.defaultProps = {
  label: '',
  modifiers: '',
  disabled: false,
};

export default Checkbox;
